import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Typography,
  Stack,
  IconButton,
} from '@mui/material';
import LinkedIn from '@mui/icons-material/LinkedIn';
import GitHub from '@mui/icons-material/GitHub';
import altairLogo from '../assets/image.png';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 8,
        borderTop: '2px solid transparent',
        borderImage: 'linear-gradient(90deg, #ff6b6b, #4ecdc4, #ffd93d) 1',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(15, 20, 25, 0.98) 0%, rgba(22, 28, 36, 0.95) 100%)',
          backdropFilter: 'blur(20px)',
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Box
            component="img"
            src={altairLogo}
            alt="Altaïr Studios"
            sx={{
              height: 45,
              width: 'auto',
              mb: 2,
              opacity: 0.7,
              transition: 'opacity 0.2s ease',
              '&:hover': {
                opacity: 1,
              },
            }}
          />
          
          <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 3 }}>
            <IconButton
              href="https://www.linkedin.com/in/michaël-cadoul-7a5a60178/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#8b949e',
                border: '1px solid rgba(255, 107, 107, 0.2)',
                borderRadius: '8px',
                padding: '8px',
                transition: 'all 0.2s ease',
                '&:hover': {
                  color: '#ff6b6b',
                  borderColor: '#ff6b6b',
                  backgroundColor: 'rgba(255, 107, 107, 0.1)',
                },
              }}
            >
              <LinkedIn fontSize="small" />
            </IconButton>
            <IconButton
              href="https://github.com/xenom34/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#8b949e',
                border: '1px solid rgba(78, 205, 196, 0.2)',
                borderRadius: '8px',
                padding: '8px',
                transition: 'all 0.2s ease',
                '&:hover': {
                  color: '#4ecdc4',
                  borderColor: '#4ecdc4',
                  backgroundColor: 'rgba(78, 205, 196, 0.1)',
                },
              }}
            >
              <GitHub fontSize="small" />
            </IconButton>
          </Stack>
          
          <Typography
            variant="body2"
            sx={{
              color: '#8b949e',
              fontSize: '0.875rem',
              fontWeight: 500,
            }}
          >
            © {currentYear} Michaël Cadoul • {t('footer.rights')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
